/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type MigrateTrelloDataInput = {
    token: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type migrateTrelloDataMutationVariables = {
    input: MigrateTrelloDataInput;
};
export type migrateTrelloDataMutationResponse = {
    readonly migrateTrelloData: {
        readonly success: boolean | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type migrateTrelloDataMutation = {
    readonly response: migrateTrelloDataMutationResponse;
    readonly variables: migrateTrelloDataMutationVariables;
};



/*
mutation migrateTrelloDataMutation(
  $input: MigrateTrelloDataInput!
) {
  migrateTrelloData(input: $input) {
    success
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "MigrateTrelloDataInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MigrateTrelloDataPayload",
    "kind": "LinkedField",
    "name": "migrateTrelloData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "migrateTrelloDataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "migrateTrelloDataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "migrateTrelloDataMutation",
    "operationKind": "mutation",
    "text": "mutation migrateTrelloDataMutation(\n  $input: MigrateTrelloDataInput!\n) {\n  migrateTrelloData(input: $input) {\n    success\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = '7dcc7698f60f49ddcb9ebd886cc0b98e';
export default node;
